import { Routes } from '@angular/router';
import { CanActivateguard } from '../../service/auth-service.service';


export const DatacleansingRoutes: Routes = [
    { path: 'import', loadComponent: () => import('../Data Cleansing/import/import.component').then(m => m.ImportComponent), canActivate: [CanActivateguard] },
    { path: 'export', loadComponent: () => import('../Data Cleansing/export/export.component').then(m => m.ExportComponent), canActivate: [CanActivateguard] },
    { path: 'assignwork', loadComponent: () => import('../Data Cleansing/assignwork/assignwork.component').then(m => m.AssignworkComponent), canActivate: [CanActivateguard] },
    { path: 'bulkupload', loadComponent: () => import('../Data Cleansing/bulkupload/bulkupload.component').then(m => m.BulkuploadComponent), canActivate: [CanActivateguard] },
];
